<template>
  <div v-title="$route.meta.title"
       class="asr-check-stats-table">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>录音风险管理</el-breadcrumb-item>
        <el-breadcrumb-item>录音风险项目统计</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="asr-check-stats-table__card asr-check-stats-table__card--search">
      <div class="asr-check-stats-table__card-header"
           @click="searchExpanded = !searchExpanded">
        <span>搜索</span>
        <i :class="searchExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
      </div>

      <el-form v-show="searchExpanded"
               :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="left"
               size="small"
               class="asr-check-stats-table__search-form"
               @submit.native.prevent="onSearch()">
        <div class="asr-check-stats-table__search-grid">
          <el-form-item label="项目"
                        prop="projectid">
            <remote-select class="width-max"
                           clearable
                           id-key="number"
                           label-key="name"
                           value-key="id"
                           placeholder="请选择项目"
                           v-model="search.projectid"
                           :query-request="getProjectTableQuery"
                           :find-request="getProjectDetail" />
          </el-form-item>
          <el-form-item label="更新时间"
                        prop="updated_at">
            <el-date-picker v-model="search.updated_at"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetimerange"
                            :picker-options="dateTimePickerRangeOptions"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            class="width-max"
                            :default-time="['00:00:00', '23:59:59']"
                            clearable />
          </el-form-item>
        </div>
        <div class="asr-check-stats-table__search-actions">
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索</el-button>
          <el-button icon="el-icon-refresh"
                     @click="resetSearch()">重置</el-button>
        </div>
      </el-form>
    </div>

    <div class="asr-check-stats-table__card">
      <div class="asr-check-stats-table__card-header"
           @click="listExpanded = !listExpanded">
        <span>列表</span>
        <div class="asr-check-stats-table__card-header-actions">
          <el-button type="text"
                     icon="el-icon-refresh"
                     class="asr-check-stats-table__header-action"
                     @click.stop="onRefresh()" />
          <span class="asr-check-stats-table__header-action">
            <i :class="listExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
          </span>
        </div>
      </div>

      <div v-show="listExpanded"
           class="asr-check-stats-table__list-body">
        <div class="asr-check-stats-table__toolbar">
          <el-button type="success"
                     size="small"
                     icon="sj-icon-export"
                     @click="onExportSearch">按搜索结果导出</el-button>
        </div>
        <div class="asr-check-stats-table__table-wrap">
          <el-table :data="table"
                    class="asr-check-stats-table__table"
                    style="width: 100%">
            <el-table-column prop="projectid"
                             label="项目ID"
                             width="100" />
            <el-table-column prop="project_name"
                             label="项目名称"
                             min-width="180"
                             show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.project_name || '-' }}</template>
            </el-table-column>
            <el-table-column prop="checked_order_count"
                             label="已检查工单数"
                             width="120"
                             align="right" />
            <el-table-column prop="trigger_risk_order_count"
                             label="风险工单数"
                             width="110"
                             align="right">
              <template slot-scope="scope">
                <span :class="{ 'asr-check-stats-table__risk-count': Number(scope.row.trigger_risk_order_count) > 0 }">
                  {{ scope.row.trigger_risk_order_count }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="risk_rate_text"
                             label="风险率"
                             width="90"
                             align="right">
              <template slot-scope="scope">{{ scope.row.risk_rate_text || '-' }}</template>
            </el-table-column>
            <el-table-column prop="total_record_asr_minutes"
                             label="ASR时长(分钟)"
                             width="130"
                             align="right" />
            <el-table-column prop="total_llm_tokens"
                             label="LLM Token"
                             min-width="120"
                             align="right" />
            <el-table-column prop="updated_at"
                             label="更新时间"
                             width="170">
              <template slot-scope="scope">{{ scope.row.updated_at || '-' }}</template>
            </el-table-column>
            <el-table-column fixed="right"
                             label="操作"
                             width="200"
                             align="left">
              <template slot-scope="scope">
                <div class="asr-check-stats-table__actions">
                  <router-link :to="{ path: '/audio-asr-check/result', query: { projectid: scope.row.projectid } }"
                               class="asr-check-stats-table__action is-view">
                    查看风险
                  </router-link>
                  <a href="javascript:;"
                     class="asr-check-stats-table__action is-reset"
                     @click.prevent="onResetLlm(scope.row)">
                    重新检测风险
                  </a>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="pagination">
          <el-pagination background
                         @size-change="handleSizePageChange"
                         @current-change="handleCurrentPageChange"
                         :current-page="pagination.current_page"
                         :page-sizes="[20, 50, 100, 200]"
                         :page-size="pagination.per_page"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="pagination.total" />
        </div>
      </div>
    </div>

    <el-dialog title="按项目重新检测风险"
               :visible.sync="resetLlmDialogVisible"
               width="480px"
               append-to-body>
      <p class="asr-check-stats-table__reset-tip">
        将把该项目下「成功 / 失败」工单重新排队：ASR 失败会重新 ASR，其余仅重跑 LLM；由定时任务执行。用量（ASR 分钟 / LLM Token）会在原值上累加，不会清零。
      </p>
      <el-form label-width="80px"
               size="small">
        <el-form-item label="项目"
                      required>
          <remote-select class="width-max"
                         clearable
                         id-key="number"
                         label-key="name"
                         value-key="id"
                         placeholder="请选择项目"
                         v-model="resetLlmProjectId"
                         :query-request="getProjectTableQuery"
                         :find-request="getProjectDetail" />
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button size="small"
                   @click="resetLlmDialogVisible = false">取消</el-button>
        <el-button type="primary"
                   size="small"
                   :loading="resetLlmSubmitting"
                   @click="submitResetLlmDialog">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import table, { removeEmptyParams } from '@core/mixins/table'
import dateTimePicker from '@core/mixins/dateTimePicker'

export default {
  mixins: [table, dateTimePicker],
  data () {
    return {
      searchExpanded: true,
      listExpanded: true,
      search: {
        projectid: null,
        updated_at: [],
      },
      table: [],
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0,
      },
      searchFieldType: {
        projectid: String,
        updated_at: Array,
      },
      resetLlmDialogVisible: false,
      resetLlmProjectId: null,
      resetLlmSubmitting: false,
    }
  },
  methods: {
    ...request.map([
      'getProjectTable',
      'getProjectDetail',
    ]),
    getProjectTableQuery (params) {
      return this.getProjectTable(Object.assign({
        current_page: 1,
        per_page: 20,
      }, params || {}))
    },
    getTableData (params) {
      return request.page('queryAudioAsrCheckProjectStats', params)
    },
    openResetLlmDialog (projectid) {
      this.resetLlmProjectId = projectid || this.search.projectid || null
      this.resetLlmDialogVisible = true
    },
    submitResetLlmDialog () {
      if (!this.resetLlmProjectId) {
        this.$message.warning('请选择项目')
        return
      }
      this.confirmResetLlm(this.resetLlmProjectId, '').then(() => {
        this.resetLlmDialogVisible = false
      }).catch(() => {})
    },
    onResetLlm (row) {
      if (!row || !row.projectid) {
        this.$message.warning('缺少项目ID')
        return
      }
      const name = row.project_name ? `「${row.project_name}」` : ''
      this.confirmResetLlm(row.projectid, name).catch(() => {})
    },
    confirmResetLlm (projectid, projectNameLabel) {
      const label = projectNameLabel || `项目 ${projectid}`
      return this.$confirm(
        `确认将${label}下成功和失败的工单重新排队检测风险？ASR 失败会重新 ASR，其余仅重跑 LLM；用量在原值上累加。`,
        '重新检测风险',
        { type: 'warning' }
      ).then(() => {
        this.resetLlmSubmitting = true
        return request.common('resetAudioAsrCheckProjectLlm', { projectid }).then(({ data }) => {
          const affected = data && data.affected != null ? data.affected : 0
          this.$message.success(`已重置 ${affected} 条工单，等待定时任务重新检测风险`)
          this.onRefresh()
        })
      }).finally(() => {
        this.resetLlmSubmitting = false
      })
    },
    onExportSearch () {
      const exportParams = removeEmptyParams(_.cloneDeep(this.lastSeachParams || {}))
      delete exportParams.current_page
      delete exportParams.per_page
      delete exportParams['']
      this.$export(`${this.$route.meta.title}_搜索结果`, {
        fileHeader: [
          { key: 'projectid', text: '项目ID' },
          { key: 'project_name', text: '项目名称' },
          { key: 'checked_order_count', text: '已检查工单数' },
          { key: 'trigger_risk_order_count', text: '风险工单数' },
          { key: 'risk_rate_text', text: '风险率' },
          { key: 'total_record_asr_minutes', text: 'ASR时长(分钟)' },
          { key: 'total_llm_tokens', text: 'LLM Token' },
          { key: 'updated_at', text: '更新时间' },
        ],
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: exportParams,
      })
    },
    resetSearch () {
      this.$refs[this.refSearchForm].resetFields()
      this.onSearch()
    },
  },
}
</script>

<style lang="scss" scoped>
.asr-check-stats-table {
  &__card {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    overflow: hidden;

    & + & {
      margin-top: 16px;
    }
  }

  &__card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 24px;
    border-bottom: 1px solid #ebeef5;
    cursor: pointer;
    user-select: none;
    color: #606266;
    font-size: 14px;
    font-weight: 500;

    i {
      color: #909399;
    }
  }

  &__card-header-actions {
    display: flex;
    align-items: center;
    gap: 8px;

    ::v-deep .asr-check-stats-table__header-action.el-button {
      min-width: 24px;
      padding: 0;
      margin: 0;
    }
  }

  &__header-action {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    padding: 0;
    margin: 0;
    color: #909399;
    flex-shrink: 0;
    line-height: 1;

    i {
      font-size: 14px;
    }
  }

  &__search-form {
    padding: 16px 24px 20px;
  }

  &__search-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px 16px;
  }

  &__search-actions {
    margin-top: 16px;
    padding-top: 4px;
  }

  &__list-body {
    padding: 16px;
  }

  &__toolbar {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
    padding: 0 0 16px;
  }

  &__table-wrap {
    border: 1px solid #ebeef5;
    border-radius: 8px;
    overflow: hidden;
    margin-top: 0;

    ::v-deep .el-table::before,
    ::v-deep .el-table::after {
      display: none;
    }

    ::v-deep .el-table__body tr:last-child td {
      border-bottom: none;
    }
  }

  &__table {
    ::v-deep {
      th {
        background: #f5f7fa;
        color: #909399;
        font-size: 12px;
        font-weight: 500;
      }

      td {
        font-size: 14px;
        color: #303133;
      }

      .el-table__row:hover > td {
        background: #fafafa;
      }
    }
  }

  &__risk-count {
    color: #dc2626;
    font-weight: 500;
  }

  &__actions {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    padding: 4px 0;
  }

  &__action {
    display: inline-block;
    padding: 4px 10px;
    border-radius: 4px;
    font-size: 12px;
    line-height: 18px;
    font-weight: 500;
    background: #fff;
    cursor: pointer;
    transition: background-color 0.15s ease;
    outline: none;
    font-family: inherit;
    text-decoration: none;

    &.is-view {
      color: #606266;
      border: 1px solid #909399;
    }

    &.is-reset {
      color: #e6a23c;
      border: 1px solid #e6a23c;
    }

    &:hover {
      background: #f9fafb;
    }
  }

  &__reset-tip {
    margin: 0 0 16px;
    font-size: 13px;
    color: #606266;
    line-height: 1.6;
  }

  .pagination {
    margin: 16px auto 0;
    text-align: center;
  }
}

@media (max-width: 1200px) {
  .asr-check-stats-table {
    &__search-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
}

@media (max-width: 768px) {
  .asr-check-stats-table {
    &__search-grid {
      grid-template-columns: 1fr;
    }
  }
}
</style>

<style lang="scss">
.asr-check-stats-table__search-form {
  .el-form-item {
    margin-bottom: 0;
  }

  .el-form-item__label {
    color: #606266;
    font-size: 13px;
    line-height: 32px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/audio-asr-check/pages/AudioAsrCheckStatsTable.vue